import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonContent,
  IonMenuButton,
  IonItem,
  IonText,
  IonGrid,
  IonCard,
  IonLabel,
  IonButton,
  IonIcon,
  IonImg,
  IonRow,
  IonCol,
  IonList,
  useIonToast,
  isPlatform,
  IonSegmentButton,
  IonSegment,
  IonFooter,
  useIonViewWillEnter,
  IonModal,
} from "@ionic/react";
import { documentTextOutline, personOutline } from "ionicons/icons";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { resetDocumentList } from "../../store/supervisorRequiredDocuments";
import { fetchHojasDeCargo } from "../../store/supervisorRequiredDocuments/actions/getHojasDeCargo";
import { UserRequiredDocuments } from "../UserRequiredDocuments";
import { FilterCreatedAtSelector } from "./components/FilterCreatedAtSelector";
import { FilterStatusSelector } from "./components/FilterStatusSelector";
import { QrCodeButton } from "./components/QrCodeButton";
import { SupervisorHojaDeCargo } from "./components/SupervisorHojaDeCargo";
import { QrModalDialog } from "./components/qrModalDialog";
import { selectUser } from "../../store/userAuthentication/selectors/selectUser";
import { findRequiredDocuments } from "../../store/requiredDocuments/actions/findRequiredDocuments";

export const SupervisorDocuments: React.FC = () => {
  const [acuerdosActive, setAcuerdosActive] = useState<boolean>(true);
  // const [colaboradoresActive, setColaboradoresActive] = useState<boolean>(false);
  const user = useSelector(selectUser);

  const isMobile = isPlatform("capacitor");

  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    dispatch(resetDocumentList());
    dispatch(fetchHojasDeCargo());
    // dispatch(findRequiredDocuments(user?.id));
  });

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Helmet>
          <title>Mi GuardService - Hojas de cargo</title>
        </Helmet>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light" />
          </IonButtons>
          <IonTitle>Hojas de cargo</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {acuerdosActive && isMobile ? <QrCodeButton text={"QR"} /> : null}
        <IonRow className="">
          <IonCol size="12">
            {/* <IonSegment
              value={acuerdosActive ? "acuerdos" : "colaboradores"}
              color="secondary"
              style={{
                maxWidth: "100%",
                position: "fixed",
                bottom: 0,
                left: 0,
                backgroundColor: "white",
                zIndex: 1000,
              }}
              mode="ios"
            >
              <IonSegmentButton
                value="acuerdos"
                onClick={() => {
                  setAcuerdosActive(true);
                  setColaboradoresActive(false);
                }}
              >
                <IonIcon icon={documentTextOutline} />
                <IonLabel>Hojas de cargo</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton
                value="colaboradores"
                onClick={() => {
                  setAcuerdosActive(false);
                  setColaboradoresActive(true);
                }}
              >
                <IonIcon icon={personOutline} />
                <IonLabel>Documentos Requeridos</IonLabel>
              </IonSegmentButton>
            </IonSegment> */}
          </IonCol>
          {
            acuerdosActive && (
              <>
                <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                  <SupervisorHojaDeCargo />
                </IonCol>
              </>
            )
            // ) : (
            //   <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
            //     <UserRequiredDocuments />
            //   </IonCol>
            // )
          }

          <IonFooter style={{ height: "2rem" }} className="ion-no-border"></IonFooter>
        </IonRow>
        <FilterStatusSelector />
        <FilterCreatedAtSelector />
      </IonContent>
      <QrModalDialog />
    </IonPage>
  );
};
